<template>
  <div class="view-phantom">
    <h2 class="product-desc__title--fixed">Возможности персонализации</h2>
    <Phantom/>
  </div>
</template>

<script>
import Phantom from '@/components/Catalog/Phantom'

export default {
  name: 'ViewPhantom',
  components: {
    Phantom
  }
}
</script>

<style lang="scss">
.view-chloe {
  @at-root .fp-enabled & {
    height: calc(100vh - #{$header-height});
  }
}

@import '@/styles/fixed-title.scss';
</style>
